// extracted by mini-css-extract-plugin
export default {"root":"AvatarBubble_root__DxkmI","mediaPreview":"AvatarBubble_mediaPreview__RAeHv"};